import { Box, Card, Image, Link } from "@chakra-ui/react"
import { type DocPreviewProps } from "../../api/ratecharts"

function DocPreviewComponent({rate}: DocPreviewProps) {
    return (
        <Link
            href={rate.fk_media.path}
            rel="noopener noreferrer"
            target="_blank"
            textDecor="none"
            data-testid="doc_preview"
            _focus={{ outline: "none", boxShadow: "none" }}
            _focusVisible={{ outline: "none", boxShadow: "none" }}
            my={10}
        >
            <Box
                transformStyle="preserve-3d"
                perspective={1000}
                w="fit-content"
            >
                <Box
                    transition="transform 0.7s ease"
                    transform="rotateY(0deg)"
                    transformOrigin="left center"
                    _hover={{ transform: "rotateY(-30deg)" }}
                    zIndex={1}
                    pos="relative"
                >
                    <Card.Root
                        w="15em"
                        h="20em"
                        overflow="hidden"
                    >
                        <Image
                            src={`data:image/jpeg;base64,${rate.pdf_preview_b64}`}
                            alt={rate.label}
                            height="100%"
                        />
                        <Card.Body
                            gap="2"
                            bgColor="main"
                            color="light"
                            h="fit-content"
                            pos="absolute"
                            bottom={0}
                            width="100%"
                        >
                            <Card.Title>{rate.label}</Card.Title>
                        </Card.Body>
                    </Card.Root>
                </Box>

                <Box
                    w="15em"
                    h="20em"
                    bgColor="light"
                    pos="absolute"
                    top={0}
                    zIndex={0}
                    borderRadius={6}
                    shadow="0px 5px 15px rgba(0, 0, 0, 0.35)"
                />
            </Box>
        </Link>
    )
}

export default DocPreviewComponent